import { render } from "./LoadingSpinner.vue?vue&type=template&id=024e9689"
import script from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/LoadingSpinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "024e9689"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('024e9689', __exports__)) {
    api.reload('024e9689', __exports__)
  }
  
  module.hot.accept("./LoadingSpinner.vue?vue&type=template&id=024e9689", () => {
    api.rerender('024e9689', render)
  })

}


export default __exports__